// extracted by mini-css-extract-plugin
module.exports = {"companyMessageContainer":"styles_companyMessageContainer__1zC8M","companyMessageContent":"styles_companyMessageContent__1Tsg-"};